export default __webpack_public_path__ + "static/media/lead.5bc3ff17.png";